import React from 'react'

import {
  Rating, Icon, ChatText, FavoriteFilled, VisibilityOn, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  number, string, object, bool,
} from 'prop-types'

import shortenValue from 'Utils/ShortenValue'

import Price from './Price'

function ShortModelInfo({
  title,
  modelRating = 0,
  modelRatingCount = 0,
  commentCount = 0,
  likeCount = 0,
  viewCount = 0,
  priceInfo = null,
  fullScreenGallery = false,
}) {
  const showLightText = fullScreenGallery
  const textClass = classnames(
    'cgt-legacy-text-tiny',
    showLightText ? 'cgt-legacy-color-typography-secondary-light' : 'cgt-legacy-color-typography-disabled',
  )
  const roundedModelRating = Math.round(modelRating)

  function renderRating() {
    if (modelRatingCount === 0) {
      return null
    }

    return (
      <span className={textClass}>
        <Rating
          className="short-model-info__stats-rating"
          id="rating"
          initialValue={roundedModelRating}
          isCheckboxHidden
          isDisabled
          isLight={showLightText}
          isReadOnly
          size="tiny"
        />
        {shortenValue(modelRatingCount)}
      </span>
    )
  }

  function renderStat(count, icon) {
    if (!count) {
      return null
    }

    return (
      <span className={textClass}>
        <Icon svgComponent={icon} color={showLightText ? 'light' : 'dark'} size="small" />
        {shortenValue(count)}
      </span>
    )
  }

  return (
    <div className="short-model-info">
      <div className="short-model-info__top-row">
        <h3
          className={classnames(
            'short-model-info__top-row-title',
            showLightText && 'cgt-legacy-heading--dark-bg',
          )}
        >
          {title}
        </h3>
        {priceInfo && <Price {...priceInfo} />}
      </div>
      <div className="short-model-info__stats">
        {renderRating()}
        {renderStat(commentCount, ChatText)}
        {renderStat(likeCount, FavoriteFilled)}
        {renderStat(viewCount, VisibilityOn)}
      </div>
    </div>
  )
}

ShortModelInfo.propTypes = {
  title: string.isRequired,
  modelRating: number,
  modelRatingCount: number,
  commentCount: number,
  likeCount: number,
  viewCount: number,
  priceInfo: object,
  fullScreenGallery: bool,
}

export default ShortModelInfo
